var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbout4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_33_165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.125 4.375H0.625V39.375H28.125V4.375Z",
    fill: "white",
    stroke: "#2D142C",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.625 29.375L11.25 24.375L18.125 28.75L23.125 22.5",
    stroke: "#EE4540",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.625 30.625C6.31536 30.625 6.875 30.0654 6.875 29.375C6.875 28.6846 6.31536 28.125 5.625 28.125C4.93464 28.125 4.375 28.6846 4.375 29.375C4.375 30.0654 4.93464 30.625 5.625 30.625Z",
    fill: "white",
    stroke: "#EE4540",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.125 23.75C23.8154 23.75 24.375 23.1904 24.375 22.5C24.375 21.8096 23.8154 21.25 23.125 21.25C22.4346 21.25 21.875 21.8096 21.875 22.5C21.875 23.1904 22.4346 23.75 23.125 23.75Z",
    fill: "white",
    stroke: "#EE4540",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.125 30C18.8154 30 19.375 29.4404 19.375 28.75C19.375 28.0596 18.8154 27.5 18.125 27.5C17.4346 27.5 16.875 28.0596 16.875 28.75C16.875 29.4404 17.4346 30 18.125 30Z",
    fill: "white",
    stroke: "#EE4540",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11.25 25.625C11.9404 25.625 12.5 25.0654 12.5 24.375C12.5 23.6846 11.9404 23.125 11.25 23.125C10.5596 23.125 10 23.6846 10 24.375C10 25.0654 10.5596 25.625 11.25 25.625Z",
    fill: "white",
    stroke: "#EE4540",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M11.25 0.625H39.375V19.375H20L16.25 22.5V19.375H11.25V0.625Z",
    fill: "white",
    stroke: "#2D142C",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M25.625 6.25H20.625V12.5H25.625V6.25Z",
    fill: "white",
    stroke: "#EE4540",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M31.25 14.375L25.625 12.5V6.25L31.25 4.375V14.375Z",
    fill: "white",
    stroke: "#EE4540",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M25 16.25H22.5L21.875 12.5H24.375L25 16.25Z",
    fill: "white",
    stroke: "#EE4540",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M20.625 6.875H18.125V11.875H20.625V6.875Z",
    fill: "white",
    stroke: "#EE4540",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M4.375 33.75H24.375",
    stroke: "#2D142C",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout4);
export default __webpack_public_path__ + "static/media/about4.6b00ef4e14d5d3854ff5fe96afee5db0.svg";
export { ForwardRef as ReactComponent };